import React, { useEffect, useState } from 'react';
// import { TrendingDown, TrendingUp } from 'react-feather';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { ScheduledList } from '../../../apiController';
// import { AllCampaignsTitle, DailyDropdown } from '../../../Constant';
// import { AllCampaignsTable } from '../../../Data/Social';
// import DropdownCommon from '../../Common/Dropdown'; 

const Schedule = ({date}) => {

  const [schedule ,setScheduledList] = useState([])

  useEffect(()=>{
    console.log(date)
    scheduledList(date)
  },[date]);


  const scheduledList = async (date) => {
    const response = await ScheduledList()
    if(response.status === true){
      const appointmentData = response.data

      // const formattedDate = new Date(date).toISOString().split('T')[0];

      const filteredAppointments = appointmentData.filter(appointment => {
        const appointmentDate = new Date(appointment.appointment_date).toISOString().split('T')[0];
        return appointmentDate === date;
    });
      console.log(filteredAppointments)
      setScheduledList(filteredAppointments)
    }
  }

  console.log(schedule)
  const AllCampaignsTable ={
    header: ['S No', 'Doctor Name', 'Patient Name', 'Appointment Date', 'Appointment Time', 'Status'],
    // header: ['AD Platform', 'Campaign', 'GEO', 'Profitability', 'Max Participation Avai.', 'Status', 'Create'],
    body:  schedule?.map((item, ind)=>(
      {
        SNo: ind+1,
        // icon: 'facebook',
        DoctorName: `${item.doctor_first_name} ${item.doctor_sur_name}`,
        PatientName: `${item.patient_first_name} ${item.patient_sur_name}`,
        AppointmentDate: item.appointment_date,
        AppointmentTime: item.appointment_time,
        status: item.appointment_status,
      }
    ))
  }
  return (
    <Card>
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <H5 className='m-0'>Schedule</H5>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            {/* Date: 03-05-2024 */}
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
          <Table>
            <thead>
              <tr>
                {AllCampaignsTable.header.map((item, i) => (
                  <th key={i} className='f-light'>
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              { AllCampaignsTable.body.map((item, i) => (
                <tr key={i}>
                  {/* <td className={`border-icon ${item.}`}> */}
                  <td className={`border-icon ${item.ADPlatform}`}>
                    <div>
                      <div className='social-circle'>
                    {item.SNo}
                        {/* <i className={`fa fa-${item.icon}`} /> */}
                      </div>
                    </div>
                  </td>
                  <td>{item.DoctorName}</td>
                  <td>{item.PatientName}</td>
                  <td>
                    <div className='change-currency'>
                      {/* {item.profitability > 40 ? <TrendingUp className='font-success me-1' /> : <TrendingDown className='font-danger me-1' />} */}
                      {item.AppointmentDate}
                    </div>
                  </td>
                  <td>{item.AppointmentTime}</td>
                  <td>
                    {item.status}
                  </td>
                  {/* <td>
                    <button className='plus-btn'>+ </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default Schedule;
